"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import { Button } from "flowbite-react";

const Titleheading = () => {
  return (
    <div>
      <section
        className="relative py-32 md:py-28 lg:py-36 -mt-24"
        style={{
          backgroundImage: 'url("/images/slide1.jpg")',
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black opacity-50 z-10"></div>

        {/* Content */}
        <div className="relative z-20 max-w-screen-xl mx-5 lg:mx-auto">
          <div className="grid grid-cols-1 gap-3 items-center justify-between text-gray-300">
            <div>
              <h1 className="font-bold text-white text-4xl my-3">Project</h1>
              <p>
                <a href="/" className="text-orange-600 hover:text-orange-300">
                  Aria
                </a>{" "}
                / Project
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Titleheading;
